import React from 'react';
import { Link } from "react-router-dom";   
import {Container} from "react-bootstrap"; 
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HomeIcon from '@material-ui/icons/Home';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import GroupIcon from '@material-ui/icons/Group';
import Button from '@material-ui/core/Button'
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext'


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      background: '#008DB9'
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  // content: {
  //   flexGrow: 1,
  //   padding: theme.spacing(3),
  // },
}));

function ResponsiveDrawer(props) {
  const history = useHistory()
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {currentUser, logout} = useAuth();

  const logoutHandler = () =>{
    logout();
    history.push("/");
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const itemsList = currentUser.role==="superadmin" ? [
    {
      text: "Home",
      icon: <HomeIcon />,
      onClick: () => history.push("/")
    },
    {
      text: "Dashboard",
      icon: <DashboardIcon />,
      onClick: () => {
        if(currentUser && currentUser.role==="superadmin") return history.push("/hospitals");
        if(currentUser && currentUser.role==="admin") return history.push(currentUser.path.toLowerCase());
        if(currentUser && currentUser.role==="user") return history.push(currentUser.path.toLowerCase());
      }
    },
    {
      text: "All Users",
      icon: <GroupIcon />,
      onClick: () => history.push("/central-dashboard")
    },
    {
      text: "Logout",
      icon: <ExitToAppIcon />,
      onClick: logoutHandler
    }

  ]:[
    {
      text: "Home",
      icon: <HomeIcon />,
      onClick: () => history.push("/")
    },
    {
      text: "Dashboard",
      icon: <DashboardIcon />,
      onClick: () => {
        if(currentUser && currentUser.role==="superadmin") return history.push("/hospitals");
        if(currentUser && currentUser.role==="admin") return history.push(currentUser.path.toLowerCase());
        if(currentUser && currentUser.role==="user") return history.push(currentUser.path.toLowerCase());
      }
    },
    {
      text: "Logout",
      icon: <ExitToAppIcon />,
      onClick: logoutHandler
    }

  ];



  const itemsList2 = [
    {
      text: "Login",
      icon : <AccountCircleIcon/>,
      onClick: () => history.push("/login")
    }
  ]
  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
      {itemsList.map((item, index) => {
          const { text, icon, onClick } = item;
          return (
            <ListItem button key={text} onClick={onClick}>
              {icon && <ListItemIcon>{icon}</ListItemIcon>}
              <ListItemText primary={text} />
            </ListItem>
          );
        })}
      </List>
      <Divider />
      <List>
      {!currentUser && itemsList2.map((item, index) => {
          const { text, icon, onClick } = item;
          return (
            <ListItem button key={text} onClick={onClick}>
              {icon && <ListItemIcon>{icon}</ListItemIcon>}
              <ListItemText primary={text} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Isoport Chamber
          </Typography>
          {/* <span style={{ marginLeft: "auto" }}>
            <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <Typography variant="h6" noWrap>
            Login
            </Typography>
                {/* <AccountCircle /> */}
              {/* </IconButton> */}
          {/* </span> */} 
          {/* <span className="ml-auto"><span style={{fontSize:"1.1rem"}}>{currentUser.name} </span>{currentUser.role!=="user"&&<span style={{fontSize:"0.9rem", color:"yellow"}}>({currentUser.role})</span>}</span> */}
          {/* <Button variant="contained" className="ml-auto" onClick={logoutHandler}>
            Logout
          </Button> */}

          
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>

    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;